module.exports = __webpack_public_path__ + "static/img/Ben.Howlett.275f18e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben.Howlett.jpg
// module id = QASw
// module chunks = 0